import { css, Global } from '@emotion/react'
import * as React from 'react'

import { defaultLineHeight } from '~ui/styleGuide/fontStyles'

import { blankaCSS } from './blanka.css'
import { normalizeCSS } from './normalize.css'

export const globalStyleCss = css`
  ${normalizeCSS}
  ${blankaCSS}

  // by default apply the more natural box layout model to all HTML elements, but allow overrides
  html {
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    // default line height
    line-height: ${defaultLineHeight};
    -webkit-font-smoothing: antialiased !important;
  }

  button {
    -webkit-appearance: none;
    border: none;
    color: inherit; // Safari adds a light blue by default which messes up the inheritance
  }
`

type TProps = NoChildren

export const BaseGlobalStyles: React.FC<TProps> = () => {
  return <Global styles={globalStyleCss} />
}
